import { Box, Typography } from "@mui/material";
import {
  CustomizePlanCoverage,
  ExtraCoverageCustomizationCard,
} from "@covertree/new-business-forms";

interface ExtraCoveragesCustomizationProps {
  coverages: CustomizePlanCoverage[];
  loading?: boolean;
  stateCode: string;
  isMineSubsidenceBlocked: boolean;
}

export function ExtraCoveragesCustomization({
  coverages,
  loading,
  stateCode,
  isMineSubsidenceBlocked,
}: ExtraCoveragesCustomizationProps) {
  if (!coverages.length) return null;

  return (
    <Box mt={6} mb={2}>
      <Typography variant="h3">Add-ons</Typography>

      {coverages.map((coverage) => {
        const isMineSubsidence =
          coverage.validationKey === "mineSubsidenceScheduled_value";

        return (
          <Box mt={3} key={coverage.validationKey}>
            <ExtraCoverageCustomizationCard
              coverage={coverage}
              infoMessage={
                isMineSubsidence && isMineSubsidenceBlocked
                  ? "Mine Subsidence coverage was removed because Other Structures coverage is set to $0."
                  : ""
              }
              name={
                coverage.validationKey === "scheduledPersonalProperty_value" ||
                coverage.validationKey === "identityFraudExpense_value"
                  ? `policyLevelCoverages.${coverage.validationKey}`
                  : `units.0.unitLevelCoverages.${coverage.validationKey}`
              }
              stateCode={stateCode}
              disabled={
                loading || (isMineSubsidence && isMineSubsidenceBlocked)
              }
            />
          </Box>
        );
      })}
    </Box>
  );
}
